var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBaselinePayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 525V225C712.5 183.75 678.75 150 637.5 150H112.5C71.25 150 37.5 183.75 37.5 225V525C37.5 566.25 71.25 600 112.5 600H637.5C678.75 600 712.5 566.25 712.5 525ZM375 487.5C312.75 487.5 262.5 437.25 262.5 375C262.5 312.75 312.75 262.5 375 262.5C437.25 262.5 487.5 312.75 487.5 375C487.5 437.25 437.25 487.5 375 487.5ZM862.5 262.5V675C862.5 716.25 828.75 750 787.5 750H150V675H787.5V262.5H862.5Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselinePayments);
export default __webpack_public_path__ + "static/media/ic_baseline-payments.3491d3a1b5e5ca68b8fb6c86bf26488b.svg";
export { ForwardRef as ReactComponent };